import axios from 'axios'

var qs = require("qs")
var root = window.API_ROOT
var ossipath = window.OSSI_Path

//multipart/form-data
//application/x-www-form-urlencoded

//登录
export const login = (params,isMySystem) => {
  return axios.post((isMySystem ? root : ossipath) + '/ossi/login', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}


export const essiLorProduct = (params) => {
  return axios.post(root + '/ossi/essiLorProduct', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const essiLorPartner = (params) => {
  return axios.post(root + '/ossi/essiLorPartner', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const essiLorSaleOrder = (params) => {
  return axios.post(root + '/ossi/essiLorSaleOrder', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getEssilorBackinfo = (params) => {
  return axios.post(root + '/ossi/getEssilorBackinfo', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const TPDStockCode = (params) => {
  return axios.post(root + '/ossi/TPDStockCode', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const TPDStockQty= (params) => {
  return axios.post(root + '/ossi/TPDStockQty', qs.stringify(params), {
    noloading: true,
    headers: {"Content-Type": "application/x-www-form-urlencoded"}
  })
}

export const getLogisticCode=(params)=>{
  return axios.post(root + '/ossi/getLogisticCode', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listErrorinterface=()=>{
  return axios.post(root + '/ossi/listErrorinterface', null, {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const StockCode = (params) => {
  return axios.post(root + '/ossi/StockCode', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}


export const orderGoBack=(url,params) => {
  return axios.post(url, qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getGoBack= (params) => {
  return axios.post(root + '/ossi/getGoBack', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const orderStore= (params) => {
  return axios.post(root + '/ossi/orderStore', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const orderStoreBatch= (params) => {
  return axios.post(root + '/ossi/orderStoreBatch', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const ssoBuyWeb = (params) => {
  return axios.post(root + '/ossi/ssoBuyWeb', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//余额
export const accountBalance = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/accountBalance', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getBalabceRecharge = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/getBalabceRecharge', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getCashRecharge = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/getCashRecharge', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const createOrder = (params,ssotoken,isMySystem) => {
  if (ssotoken && ssotoken.indexOf('http') > -1) {
    params["backurl"] = window.location.protocol + root;
    if (ssotoken.split('?')[0] == 'http://thisapi') {
      params["ssosecret"] = ssotoken.split('?')[2];
      return axios.post(root + ssotoken.split('?')[1], qs.stringify(params))
    } else {
      return axios.post(ssotoken.split('?')[0] + '/store/createOrder', qs.stringify(params), {
        authorization: ssotoken.split('?')[1],
        headers: {"Content-Type": "application/x-www-form-urlencoded"}
      })
    }
  } else {
    return axios.post((isMySystem ? root : ossipath) + '/ossi/createOrder', qs.stringify(params), {
      ssotoken: ssotoken,
      headers: {"Content-Type": "application/x-www-form-urlencoded"}
    })
  }
}

export const urlOrder = () => {
  return window.location.protocol +  root
}

export const needsupplystore = () => {
  return (root.indexOf('lxpj2bapi')>-1) ;//老仙的系统才触发查询
}
export const supplystoreNum = (params,ssotoken,isMySystem) => {
  return axios.post((isMySystem ? root : ossipath)  + '/warehouse/store/storeNum', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const backOrder = (params,ssotoken,isMySystem) => {
  return axios.post((isMySystem ? root : ossipath) + '/ossi/backOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listOrder = (params,ssotoken,isMySystem) => {
  return axios.post((isMySystem ? root : ossipath) + '/ossi/listOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const detailOrder = (params,ssotoken,isMySystem) => {
  return axios.post((isMySystem ? root : ossipath) + '/ossi/detailOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const relatedOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/relatedOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const regist = (params,isMySystem) => {
  return axios.post((isMySystem?root:ossipath) + '/ossi/regist', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const registCheck = (params,isMySystem) => {
  return axios.post((isMySystem?root:ossipath) + '/ossi/registCheck', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const registDraw = (params,isMySystem) => {
  return axios.post((isMySystem?root:ossipath) + '/ossi/registDraw', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listSupplier = (params) => {
  return axios.post(ossipath + '/ossi/listSupplier', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const empower = (params) => {
  return axios.post(root + '/ossi/empower', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listempower = (params) => {
  return axios.post(root + '/ossi/listempower', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const yaruitoken = (params) => {
  return axios.post(root + '/api/yarui/gettoken', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const yaruiorderinfos = (params) => {
  return axios.post(root + '/api/yarui/orderinfos', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const yaruiredis = (params) => {
  return axios.post(root + '/api/yarui/removeredis', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}


export const removeorderitem = (params) => {
  return axios.post(root + '/api/yarui/removeorderitem', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const changeorderprice= (params) => {
  return axios.post(root + '/api/yarui/changeorderprice', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getSupplyConfig = (params) => {
  return axios.post(root + '/ossi/getSupplyConfig', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getGoodsMapping = (params) => {
  return axios.post(root + '/ossi/getGoodsMapping', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}



// WEBPACK FOOTER //
// ./src/api/ossi.js